import { SearchSerie } from "../componentes/SearchSerie";

export function SearchSerieGrid() {
  return <SearchSerie />;
}
